import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  visit(event) {
    event.preventDefault()
    event.detail.visit(event.detail.response)
  }
}
